export enum LocalStorageRegistry {
  realEstate = 'hasDismissedRealEstateMapSrpCTA',
  registration = 'hasDismissedRegistrationCTA',
  RECENT_LOCATIONS = 'RecentSearchLocations',
}
